import { isAxiosError } from 'axios'

import type { ApiErrorResponseData } from '@/types'

export const hasFormErrorFields = (
  error: unknown
): error is { errorFields: unknown[] } =>
  typeof error === 'object' &&
  error !== null &&
  'errorFields' in error &&
  Boolean((error as { errorFields?: unknown }).errorFields)

export const getApiErrorData = (
  error: unknown
): ApiErrorResponseData | undefined =>
  isAxiosError<ApiErrorResponseData>(error) ? error.response?.data : undefined
